<kilowant-header (returned)="reset()" [disabledShadow]="userSavings()!=null && userSavings()!.saving>0" title="View Offers" [isBuyer]="true" [myKilowant]="true"></kilowant-header>
@if (account() && userSavings()!=null && userSavings()!.saving>0) {
<div class="post-header">
    <div class="wrapperMain">
        <div class="mb-10 text-center mb-10">
            <div>
                <b>
                    {{userSavings()!.saving | currency:'USD':'symbol':'1.2-2'}}@if (userSavings()!.hasMissing) {
                    <span tiyle="Savings is cumulative and may exclude accounts without consumption">*</span>
                    }
                    Saved since {{userSavings()!.startingDate | date:'MMMM yyyy'}}
                </b>
            </div>
        </div>
    </div>
</div>
}
<div class="overWrapper">
    @if (account() && (currentCost()!=null) && currentCost().length>0) {
  <div class="mb-20">
    @if (selectSupplierMode()) {
    <div class="wrapperMain">
      <div class="form buyer">
        <h3 class="title" #body>
          Confirm your current supply service price plan
        </h3>
        <div class="supply-plan-confirm">
          <div>
            <label>
              <input type="radio" name="isCommunity" value="0" (click)="selectModeChanged.set(true)" [(ngModel)]="setStartingContract" />Rhode Island Energy
              &#64; {{currentCost()[0].utilityRate | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
              <span>Month to Month</span>
            </label>
          </div>
          @if (currentCost()[0].communityRate>0) {
          <div>
            <label>
              <input type="radio" name="isCommunity" value="1" (click)="selectModeChanged.set(true)" [(ngModel)]="setStartingContract" />NextEra Energy &#64; {{currentCost()[0].communityRate | currency:'USD':'symbol':'1.5-5'}}/kWh<br />
              <span>Month to Month</span>
            </label>
          </div>
          }
          <div><label><input type="radio" name="isCommunity" value="-1" (click)="selectModeChanged.set(true)" [(ngModel)]="setStartingContract" />I use a different supplier</label></div>
          <div class="block-buttons full-width">
            <button (click)="switchToNormalMode()">Cancel</button>
            <button (click)="confirmStartingContract()" class="highlighted-button">Next</button>
          </div>
        </div>
      </div>
    </div>
    }
    @if (!selectSupplierMode()) {
    <div class="wrapperMain contracts-slider blur-in" [class]="(offersLoadingMode())?'':'active'">
      <nav mat-tab-nav-bar>
        @for (currentPosition of sliderPositions(); track currentPosition) {
        <a mat-tab-link [active]="sliderCurrentPosition()==currentPosition" (click)="contractSliderChangeSliderPosition(currentPosition)">
          {{contractSliderTextForPosition(currentPosition)}}
        </a>
        }
      </nav>
      <div class="mt-20">
        <owl-carousel-o [options]="sliderOptions" (changed)="contractSliderChanged($event)" #contractsSlider>
          @for (currentCostRec of currentCost(); track currentCostRec; let i = $index) {
          <ng-template carouselSlide [id]="i.toString()">
            <kilowant-user-current-cost-data [currentCost]="currentCostRec" [prefix]="''+i" [currentPos]="i+1" [totalNumber]="currentCost().length" [max_savings]="max_savings()" [account]="account()!" (switchUtilityAction)="switchToSelectMode()" (openCloseAction)="switchCurrentCostDataState($event)" [forceClose]="forceCloseSubject.asObservable()" [forceOpen]="forceOpenSubject.asObservable()" [autoOpenOnLoad]="autoOpenPriceHistory()" [client]="client()"></kilowant-user-current-cost-data>
          </ng-template>
          }
        </owl-carousel-o>
      </div>
    </div>
    }
    @if (!selectSupplierMode()) {
    <div class="wrapper-main-public-area home-page home-intro" [class]="((offersLoadingMode())?'full':'') + ((introHide())?' hide':'')">
      <div class="out-core" [class]="(offersLoadingMode())?'full':''">
        <div class="core">
          <div class="circle"></div>
          <div class="inner-text">
            <div class="text-block">
              <div class="stacks">
                <div class="blur-out" [class]="(offersLoadingMode())?'':'deactivate'">
                  <div class="kilowant">ai</div>
                  is searching <br />
                  <span>{{currentOffersNumber()}}</span> offers for future savings ...
                </div>
                <div class="stack blur-in" [class]="(offersLoadingMode())?'':'active'">
                  @if (!aiSubsctiptionMode()) {
                  <div class="kilowant">ai</div>
                  has generated
                  up to {{max_savings()}} savings starting {{max_savings_date() | date:'MMM yy'}}
                  }
                  @if (aiSubsctiptionMode()) {
                  <div class="stacks">
                    <div class="stack blur-out" [class]="(nooffers_slide_switch_1())?'':'deactivate'">You're currently on the lowest price plan available</div>
                    @if (activeAITask()) {
                    <div class="stack blur-in" [class]="(nooffers_slide_switch_1())?'':'active'"><span class="text-nowarp">Nonstop Shop &#174;</span> will notify you when future savings is available</div>
                    }
                    @if (!activeAITask()) {
                    <div class="stack blur-in" [class]="(nooffers_slide_switch_1())?'':'active'"><div class="kilowant">ai</div> can shop for you by clicking below</div>
                    }
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="orbit a blur-out" [class]="(offersLoadingMode())?'':'deactivate'"><div class="dot"></div></div>
          <div class="orbit b blur-out" [class]="(offersLoadingMode())?'':'deactivate'"><div class="dot"></div></div>
          <div class="orbit c blur-out" [class]="(offersLoadingMode())?'':'deactivate'"><div class="dot"></div></div>
        </div>
      </div>
    </div>
    }
    @if (account() && !selectSupplierMode() && (activeAITask()==null || (!aiSubsctiptionMode() && (numberOffersLoad()>0)))) {
    <ol class="wrapperMain kilowant-list" style="margin-top: 10px">
      @if (!aiSubsctiptionMode()) {
      <li class="home-step interactive" [class]="((startAnimation()<1)?'':((step()==1)?'active':('inactive'+((step()>1)?' with-link':''))))" #step1>
        <h3 class="title" #body>
          Select a Future Price Plan to View Details
        </h3>
        @if (step()>1) {
        <div class="inactive-step" (click)="gotoStep(1)"></div>
        }
        <div class="step-inactive-body" [style]="(interactiveStep()==1 && !viewOfferDetails())?'height: '+(innerStep1.offsetHeight+20)+'px;':''">
          <div #innerStep1>
            @if (!aiSubsctiptionMode() && numberOffersLoad()>0) {
            <div class="home-block body">
              <div class="right-margin-icon top info-icon" [attr.style]="'z-index: 10; margin-top: '+((offerViewFilter()=='additional')?'75':'0')+'px;'" (click)="openConsumptionDialog(false, false, account()!, null);"></div>
            </div>
            }
            @if ((numberOffersLoad()>0||offerViewFilter()=='additional') && !aiSubsctiptionMode()) {
            <div class="home-block form">
              @if (numberOffersLoad()>0) {
              <div class="form body">
                <ng-container>
                  <div class="tile-legend">
                    <div>
                      <span style="background-color: rgb(255, 207, 0);"></span>
                      Kilowant ($/kWh)
                    </div>
                    @if (!isBenchmarkCommunity()) {
                    <div>
                      <span [style]="'background-color: '+RIColor"></span>
                      RI Energy ($/kWh)
                    </div>
                    }
                    @if (isBenchmarkCommunity()) {
                    <div>
                      <span [style]="'background-color: '+CommunityColor"></span>
                      NextEra Energy ($/kWh)
                    </div>
                    }
                  </div>
                  @if (offerViewFilter()=='additional') {
                  <div class="d-flex mt-20">
                    <select class="grey-select" name="filter_term" (change)="switchViewType('additional')" [(ngModel)]="additionalOffersTermsFilter">
                      <option [ngValue]="null">All Terms</option>
                      @for (t of additionalOffersUsedTerms(); track t) {
                      <option [ngValue]="t.key+'-'+t.value">{{t.key}} - {{t.value}} Months</option>
                      }
                    </select>
                    <select class="grey-select ml-10" name="filter_percent" (change)="switchViewType('additional')" [(ngModel)]="additionalOffersSavingsFilter">
                      <option [ngValue]="null">All Savings %</option>
                      @for (s of additionalOffersUsedSavings(); track s) {
                      <option [ngValue]="s.key+'-'+s.value">{{s.key}}%{{(s.value==999)?' +':' - '+s.value+'%'}} Savings</option>
                      }
                    </select>
                  </div>
                  }
                  @for (offer of offers(); track offer; let i = $index) {
                  <div class="tile body round with-ident link" [style]="(i==0)?'margin-top: 30px;':''" (click)="gotoOfferByPos(i)">
                    <button class="top-header" [title]="$any(offer.offer).termPeriod + (($any(offer.offer).termPeriod==1)?' Month starting ':' Months starting ') + datepipe.transform($any(offer.offer).termFrom, 'MMM yy')+' - '+ datepipe.transform(getTermTo($any(offer.offer).termFrom, $any(offer.offer).termPeriod), 'MMM yy')" [class]="(step()==1 && i==0 && !aiEditMode() && offerViewFilter()!='additional')?'highlighted-button':''">
                      <span>{{$any(offer.offer).termPeriod}}</span> @if ($any(offer.offer).termPeriod==1) {
                      Month
                      }@if ($any(offer.offer).termPeriod>1) {
                      Months
                      } starting {{$any(offer.offer).termFrom | date:'MMM yy'}}
                      -
                      {{getTermTo($any(offer.offer).termFrom, $any(offer.offer).termPeriod) | date:'MMM yy'}}
                    </button>
                    <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
                      <div class="d-flex">
                        <div class="tile-bolt">{{((additionalOffersPage())-((offerViewFilter()=='additional')?0:1))*3+i+1}}</div>
                        <div class="auto" #area>
                          <div><b class="f18">{{getPriceStatsSavingsText(offer.savings[diffBenchmark()], false)}}</b></div>
                          @if (showViewInUSD(offer)) {
                          <div><a (click)="openConsumptionDialog(true, false, account()!, null); $event.stopPropagation();"> <span class="f13">(Enter Usage to View $)</span></a></div>
                          }
                          <span class="auto-renewal">Includes Nonstop Shop Savings Subscription</span>
                          <div style="width: 100%" [class]="(ifNewOffer(offer))?'grayish':''">
                            <div class="d-flex small-info-block" [title]="(ifNewOffer(offer))?'':'Prices are currently '+getPriceStatsText(offer)">
                              <div class="price-statistics small visible" style="margin-left: 10px">
                                @if (!ifNewOffer(offer)) {
                                <div class="price" [ngStyle]="{'transform': 'translateX('+getPriceStatsPercent(offer)+'%)'}">
                                  <div class="dot"></div>
                                </div>
                                }
                                <div class="statistics" [style]="'width: 100px;'+((!ifPriceStatsAreActive(offer))?'opacity: 0.5':'')">
                                  <div class="low"></div>
                                  <div class="average"></div>
                                  <div class="high"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (ifNewOffer(offer)) {
                          <div class="price-statistics-info-block f13">New Price Plan Offer</div>
                          }
                          @if (!ifNewOffer(offer) && ifPriceStatsAreActive(offer)) {
                          <div class="price-statistics-info-block f13">Prices are <b [class]="getPriceStatsText(offer)">{{getPriceStatsText(offer)}}</b></div>
                          }
                          @if (!ifNewOffer(offer) && !ifPriceStatsAreActive(offer)) {
                          <div class="price-statistics-info-block f13">No data available</div>
                          }
                        </div>
                        <div style="width: 145px; padding-left: 10px; text-align: right; margin-top: -20px; margin-right: 5px" (click)="gotoOfferByPos(i)">
                          @if (viewSmallChart()[i]!=null) {
                          <kilowant-charts-home-one-offer [view]="viewSmallChart()[i]" [legend]="legend" [legendTitle]="legendTitle"
                                                          [legendPosition]="legendPosition" [showGridLines]="false" [showDataLabel]="false"
                                                          [scheme]="colorScheme" [showXAxisLabel]="false" [showYAxisLabel]="false"
                                                          [prefix]="i.toString()"
                                                          [xAxis]="false" [yAxis]="false" [xAxisLabel]="''" [yAxisLabel]="''"
                                                          [groupPadding]="2" [barPadding]="5"
                                                          [results]="offersForChart()[i]"
                                                          [savings]="savings()"
                                                          [tooltipDisabled]="true"
                                                          [showSavingsInUSD]="showSavingsIn()=='USD'"
                                                          [savingsInUSD]="savingsInUSD()">
                          </kilowant-charts-home-one-offer>
                          }
                        </div>
                      </div>
                    </div>
                    @if (i==0 && offerViewFilter()!='additional') {
                    <div class="bottom-tag">
                      Top Trending Offer
                    </div>
                    }
                  </div>
                  @if (i==0 && offerViewFilter()!='additional') {
                  <div class="bottom-space"></div>
                  }
                  }
                </ng-container>
                @if (offerViewFilter()=='additional' && additionalOffersCount()>0) {
                <div class="text-right mt-10">
                  Viewing {{(additionalOffersPage()-((offerViewFilter()=='additional')?0:1))*3+1}}-{{getLastOfferNumber()+((offerViewFilter()=='additional')?3:0)}} of {{additionalOffersCount()+3}} offers
                  <a (click)="gotoPrev();" style="margin-left: 10px; margin-right: 10px;">Prev</a>|<a (click)="this.viewAllOffers = true; this.loadOffers(false, true);" style="margin-left: 10px;" [attr.disabled]="(additionalOffersPage()*3<additionalOffersCount())?true:false">Next</a>
                </div>
                }
                @if (hasAdditionalOffers() && offerViewFilter()!='additional') {
                <div class="text-right mt-10">
                  <a (click)="switchViewType('additional')" style="margin-left: 10px;">View Additional Offers</a>
                </div>
                }
              </div>
              }
            </div>
            }
            @if (aiSubsctiptionMode()) {
            <div class="home-block body">
              <div class="right-margin-icon top info-icon" style="margin-top: 10px;" (click)="openNonstopShoppingInfo();"></div>
            </div>
            <div class="consumption-info">Sit back, relax and allow our ai to autonomously shop and switch price plans for you! Simply select your desired level of shopping sophistication and we'll report back to you when we capture savings.</div>
            }
            @if (aiSubsctiptionMode()) {
            <div class="home-block form">
              <kilowant-user-home-ai-subscription [client]="client()"
                                                  [step]="step()"
                                                  [account]="account()!"
                                                  [consumptionDataType]="(currentCost() && currentCost()[selectedOffersPeriod()])?currentCost()[selectedOffersPeriod()].consumptionData:null"
                                                  (changed)="nextContractAutoAssignedLevel($event)"
                                                  (returned)="gotoStep(2)"></kilowant-user-home-ai-subscription>
              <div class="mt-20">&nbsp;</div>
            </div>
            }
            @if (numberOffersLoad()==0 && !aiSubsctiptionMode()) {
            <div class="home-block form">
              <div class="mt-10 mb-10" style="height: 50px;">
                There is no additional offers available at the moment.
              </div>
            </div>
            }
          </div>
        </div>
        <div class="step-inactive-body" [style]="(interactiveStep()==1 && viewOfferDetails() && numberOffersLoad()>0)?'height: '+innerStep1_2.offsetHeight+'px;':''">
          <div #innerStep1_2>
            <a class="back" (click)="viewOfferDetails.set(false)"></a><div class="sub-title">Offer Details</div>
            @if (account()!=null && offers()!=null && (offers().length>0 || numberOffersLoad()>0)) {
            <div class="form body" [class]="(selectedOffer()!=null)?'selected':''">
              @if (selectedOffer()!=null) {
              <kilowant-user-home-price-statistics [selectedOffer]="selectedOffer()!" (viewChanged)="statChanged()"></kilowant-user-home-price-statistics>
              }
              @if (selectedOffer()!=null) {
              <div class="price-info chat-info-shadow selected button mt-10" [style]="'background-color:'+getKilowantColor()">
                <div class="d-flex">
                  @if (!aiSubsctiptionMode()) {
                  <div class="offer-left-title"><div class="notifiedIcon cursor-pointer mt-13" (click)="iIconPopup('<h2>The kilowant Savings Difference</h2><p><b>1. Only Savings.</b> kilowant displays only price plan offers which we forecast will save you money compared to your future market alternatives (ex. Utility or Community Energy Price). If we can\'t save you money across a future term, then the price plan offer does not appear.</p><p><b>2. Custom Savings.</b> kilowant calculates savings by weighting all pricing to your monthly usage profile because total savings is driven by how much and when you use your energy. If you don\'t input your usage data, then we use your rate class average usage profile provided by the utility.</p><p><b>3. ai Predictive Savings.</b> kilowant ai predicts if future savings is available beyond the term of your current utility and/or community energy rate filing which is typically 3-6 months. If we can\'t find you savings beyond your current price plan term, your account will return to your alternative Utility Supply Service.</p><p></p><p>* All price plan offers include a subscription to kilowant\'s Nonstop Shop &#174; ai technology, which automates the shopping for future savings opportunities beyond the term of your selected price plan...so you don\'t have to worry about term renewals at unauthorized prices. You can select your desired Level of autonomous shopping in Step 3.</p>');"></div></div>
                  }
                  <div class="auto"><div class="f22 mt-5 mb-5">{{selectedOffer()!.offer.priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh</div><div class="f14">{{selectedOffer()!.offer.termFrom | date:'M/yy'}} - {{getTermTo(selectedOffer()!.offer.termFrom, $any(selectedOffer()!.offer).termPeriod) | date:'M/yy'}}, {{$any(selectedOffer()!.offer).termPeriod}} mths</div></div>
                  <div class="save" [innerHTML]="offerInfoText(selectedOffer()!, false)"></div>
                </div>
              </div>
              }
              @if (selectedOffer()!=null) {
              <div style="margin-top: -30px;">
                <kilowant-user-home-details [selectedOffer]="selectedOffer()!"
                                            [restartNeeded]="offerDetailsRestart"
                                            [client]="client()" [account]="account()" [diffText]="getBenchmarkInfo(selectedOffer()!)"
                                            [diff]="offerDiff(selectedOffer()!)"
                                            (loaded)="slideToOffer()" (outprice)="changeSelectedPrice($event)"
                                            (acceptOffer)="gotoStep(2)"
                                            (changeDataset)="changeDataset($event)">
                </kilowant-user-home-details>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </li>
      }
      @if (step()>1 || !aiSubsctiptionMode()) {
      <li class="home-step interactive" [class]="((startAnimation()<2)?'':((step()==2)?'active':('inactive'+((step()>2)?' with-link':''))))" #step2>
        @if (!isPreregisterMode()) {
        <h3>Confirm Account Information</h3>
        }@if (isPreregisterMode()) {
        <h3>Create Your User Account</h3>
        }
        @if (step()>2 && !isPreregisterMode()) {
        <div class="inactive-step" (click)="gotoStep(2)"></div>
        }
        <div class="step-inactive-body" [style]="(interactiveStep()==2)?'height: '+innerStep2.offsetHeight+'px;':''">
          <div #innerStep2>
            @if (!user.isPreRegister && accountsSelector!=null) {
            <div class="form">
              <div class="body">
                <div class="d-flex">
                  <div class="auto">
                    <div class="checkbox-list">
                      <label>
                        <input type="checkbox" [checked]="true" [disabled]="true"> {{getName(account()!)}}
                      </label>
                    </div>
                    @if (accountsSelector.length>0 && accountsSelector[0].accountData.length>1) {
                    <hr />
                    }
                    @if (accountsSelector.length>0 && accountsSelector[0].accountData.length>1) {
                    <div class="mt-10 text-center">
                      @if (aiSubsctiptionMode()) {
                      <span>Would you like to add additional accounts to your <span class="text-nowarp">Nonstop Shop &#174;</span> Subscription?</span>
                      }
                      @if (!aiSubsctiptionMode()) {
                      <span>Would you like to include additional accounts to this price plan offer?</span>
                      }
                    </div>
                    }
                    @if (accountsSelector.length>0 && accountsSelector[0].accountData.length>1) {
                    <div>
                      <hr />
                      <div class="checkbox-list"><label><input type="checkbox" [checked]="selectAllChecked()" (click)="selectAll()" /> {{(selectAllChecked())?'Unselect':'Select'}} All</label></div>
                      @for (gData of accountsSelector; track gData; let pg = $index) {
                      @if (accountsSelector.length>1) {
                      <div [class]="(pg>0)?'mt-20':''" class="group ml-10">{{gData.groupName}}</div>
                      }
                      @for (aData of gData.accountData; track aData; let p = $index) {
                      @if (aData.id!=account()!.id) {
                      <div class="checkbox-list">
                        <label [class]="(aData.savings!=null && aData.savings.diffVsBenchmark!=null && aData.savings.diffVsBenchmark<0)?'disabled':''">
                          <input type="checkbox" [checked]="ifItemSelected(aData.id)" [disabled]="(aiSubsctiptionMode() && nextContractLevel()>1 && !aData.hasFullConsumption || !aiSubsctiptionMode() && aData.savings!=null && aData.savings.diffVsBenchmark!=null && aData.savings.diffVsBenchmark<0)" (change)="selectItem(aData.id)"> {{aData.accountName}}
                          <b class="green">{{getPriceStatsSavingsText(aData.savings, true)}}</b>
                          @if (aiSubsctiptionMode() && nextContractLevel()>1 && !aData.hasFullConsumption) {
                          <a class="consumption-edit link" (click)="openConsumptionIfConsumptionNotFilled(aData.id, aData.account)"></a>
                          }
                        </label>
                      </div>
                      }
                      }
                      }
                    </div>
                    }
                  </div>
                  <div class="icon-block"><div class="right-margin-icon top info-icon" (click)="iIconPopup('<h2>More Than One Account?</h2>Offers are valid for one or many accounts which contain the same utility, load zone, and rate class. If you have additional accounts meeting these characteristics, you can add them via the Add Accounts link in the main menu. You will then need to restart the offer acceptance process to have them included in this transaction.<br/><br/><br/><h2>Account Data Accurate?</h2>If the utility, load zone or rate class listed on your utility bill are different from what\'s listed below you will need to go to the main menu, select Accounts, delete the account, create a new account and restart the offer selection process as offers are based on your account profile.');"></div></div>
                </div>
                <div class="body mt-20">
                  <div class="d-flex">
                    @if ((selectedAccountsIds!=null && selectedAccountsIds.length<=3) || accountsDataConfirmNeeded()) {
                    <div class="auto">
                      @if (selectedAccounts.length>1) {
                      <div class="progress-tabs smaller mb-10">
                        @for (account of selectedAccounts; track account; let p = $index) {
                        <span class="link" [class]="(currentAccountStep()==(p+1))?' current':''" (click)="changeStep(p+1)">{{p+1}}</span>
                        }
                      </div>
                      }
                      @for (account of selectedAccounts; track account; let p = $index) {
                      @if (currentAccountStep()==(p+1)) {
                      <div>
                        <kilowant-account-edit [(account)]="selectedAccounts[p]!" (changed)="changeCurrentAccountInfo()" [isFromOffer]="true"
                                               [callUpdate]="callUpdate" [callCancel]="callCancel" [(currentAccountNumber)]="currentAccountNumber" (finished)="editFinish()"></kilowant-account-edit>
                      </div>
                      }
                      }
                    </div>
                    }
                  </div>
                </div>
              </div>
              @if (selectedAccountsIds!=null && selectedAccountsIds.length>3 && !accountsDataConfirmNeeded()) {
              <div class="block-buttons full-width mt-10 under-card">
                <button type="button" (click)="accountsDataConfirmNeeded.set(true)">Check Accounts</button>
                <button type="button" (click)="autoAcceptAll()">Accept All</button>
              </div>
              }
              @if ((selectedAccountsIds!=null && selectedAccountsIds.length<=3) || accountsDataConfirmNeeded()) {
              <div class="block-buttons full-width mt-10 under-card">
                <button type="button" (click)="gotoStep(1)">Cancel</button>
                <button type="button" class="highlighted-button" (click)="updateAccount()">Continue</button>
              </div>
              }
              <div>&nbsp;</div>
            </div>
            }
            @if (isPreregisterMode()) {
            <div class="form">
              <div class="body">
                <div class="d-flex">
                  <div class="auto">
                    <div class="table-view">
                      <div class="row">
                        <div class="cell">
                          <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, user.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="user.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                          @if (getVisibilityForLabel(user.firstName)) {
                          <div class="placeholder">First name</div>
                          }
                        </div>
                        <div class="cell">
                          <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, user.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="user.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                          @if (getVisibilityForLabel(user.lastName)) {
                          <div class="placeholder">Last name</div>
                          }
                        </div>
                      </div>
                    </div>
                    <input type="text" name="Company" [class]="getClassesForInput('Company', true, companyName())" (input)="resetError('Company')" placeholder="Company (optional)" [(ngModel)]="companyName" [minlength]="validationService.getMinLength('Company', 'name')" [maxlength]="validationService.getMaxLength('Company', 'name')" />
                    @if (getVisibilityForLabel(companyName())) {
                    <div class="placeholder">Company(optional)</div>
                    }
                    <input type="text"
                           name="addressLine1"
                           [class]="getClassesForInput('addressLine1', true, user.addressLine1)"
                           (input)="resetError('addressLine1')"
                           placeholder="Address Line"
                           [(ngModel)]="user.addressLine1"
                           [minlength]="validationService.getMinLength('User', 'address')"
                           [maxlength]="validationService.getMaxLength('User', 'address')" />
                    @if (getVisibilityForLabel(user.addressLine1)) {
                    <div class="placeholder">Address Line</div>
                    }
                    <div class="cols">
                      <div class="col auto">
                        <input type="text" name="City" [value]="user.city" [disabled]="true" [class]="getClassesForInput('city', true, 'city')" />
                        <div class="placeholder">City</div>
                      </div>
                      <div class="col">
                        <input type="text" name="State" [value]="getStateName(user.state)" [disabled]="true" style="width: 60px" [class]="getClassesForInput('stateId', true, 'state')" />
                        <div class="placeholder">State</div>
                      </div>
                      <div class="col">
                        <input type="text"
                               name="address"
                               [class]="getClassesForInput('zip', true, user.zip)"
                               style="width: 70px"
                               (input)="zipChanged()"
                               placeholder="Zip"
                               [(ngModel)]="user.zip"
                               [minlength]="validationService.getMinLength('User', 'zip')"
                               [maxlength]="validationService.getMaxLength('User', 'zip')" />
                        @if (getVisibilityForLabel(user.zip)) {
                        <div class="placeholder">Zip</div>
                        }
                      </div>
                    </div>
                    @if (user.state!=null && user.state.stateCode!='RI') {
                    <div class="mb-10">* kilowant is currently active in the RI Energy service territory. If you are not a RI Energy customer, we will notify you when kilowant becomes available in your region.</div>
                    }
                    <div class="table-view">
                      <div class="row">
                        <div class="cell">
                          <input type="text" name="Email" [class]="getClassesForInput('Email', true, user.email)" (input)="resetError('Email')" placeholder="Email" [(ngModel)]="user.email" [minlength]="validationService.getMinLength('User', 'email')" [maxlength]="validationService.getMaxLength('User', 'email')" />
                          @if (getVisibilityForLabel(user.email)) {
                          <div class="placeholder">Email</div>
                          }
                        </div>
                        <div class="cell">
                          <input type="text" name="Phone"
                                 [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                                 (input)="resetError('Phone')"
                                 placeholder="Mobile Phone"
                                 [dropSpecialCharacters]="false"
                                 [formControl]="currentPhoneNumber"
                                 (focus)="focusedField.set('Phone')"
                                 mask="(000) 000-0000"
                                 [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
                          @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
                          <div class="placeholder">Mobile Phone</div>
                          }
                        </div>
                      </div>
                    </div>
                    <input [type]="passwordType()" name="Password" [class]="getClassesForInput('Password', true, password())" (input)="resetError('Password')" placeholder="Password" [(ngModel)]="password" [minlength]="validationService.getMinLength('User', 'password')" [maxlength]="validationService.getMaxLength('User', 'password')" />
                    @if (getVisibilityForLabel(password())) {
                    <div class="placeholder">Password</div>
                    }
                    <div class="password-holder" (click)="showPassword(1)">
                      <i [class]="(passwordType()=='password')?'password-show':'password-hide'"></i>
                    </div>
                    <input [type]="passwordType2()" name="Password2" [class]="getClassesForInput('Password2', true, password())" (input)="resetError('Password2')" placeholder="Password (confirm)" [(ngModel)]="password2" [minlength]="validationService.getMinLength('User', 'password')" [maxlength]="validationService.getMaxLength('User', 'password')" />
                    @if (getVisibilityForLabel(password2())) {
                    <div class="placeholder">Password (confirm)</div>
                    }
                    <div class="password-holder" (click)="showPassword(2)">
                      <i [class]="(passwordType2()=='password')?'password-show':'password-hide'"></i>
                    </div>
                    @if (this.errorY().showError()) {
                    <div class="error-block">
                      {{this.errorY().error}}
                    </div>
                    }
                  </div>
                </div>
              </div>
              <div class="block-buttons full-width mt-10 under-card">
                <button type="button" (click)="gotoStep(1)">Cancel</button>
                <button type="button" class="highlighted-button" (click)="confirmLoginDetails()">Continue</button>
              </div>
              <div>&nbsp;</div>
            </div>
            }
          </div>
        </div>
      </li>
      <li class="home-step interactive" [class]="((startAnimation()<3)?'':((step()==3)?'active':('inactive'+((step()>3)?' with-link':''))))" #step3>
        <h3>Review Terms &amp; Conditions</h3>
        <div class="step-inactive-body" [style]="(interactiveStep()==3)?'height: '+innerStep3.offsetHeight+'px;':''">
          <div #innerStep3>
            @if (selectedOffer()!=null && step()==3) {
            <div class="form">
              <div class="body">
                @if (account()!=null) {
                <div>
                  <div class="title">
                    <div>
                      <div class="element-detail mlr-20">
                        <div class="account-info-block">
                          <h4>Transaction Summary</h4>
                          <div>
                            @for (rec of formatSelectedAccounts(); track rec; let p = $index) {
                            <p class="accountInfoBorder">{{rec.key}}</p>
                            @for (accountData of rec.value; track accountData; let r = $index) {
                            @if (isPreregisterMode()) {
                            <div class="checkbox-list"><label><input type="checkbox" [checked]="ifItemSelected(accountData.id)" (onchange)="addRemoveAccount(accountData.id, !ifItemSelected(accountData.id))"> {{accountData.accountName}}</label></div>
                            }
                            @if (!isPreregisterMode()) {
                            <div class="subUniqueTitle d-flex">
                              <div>{{(r+1)}}.</div>
                              <div class="auto long-text-cut">{{accountData.accountName}}</div>
                            </div>
                            }
                            }
                            }
                            <div>
                              <p class="accountInfoBorder">Supplier</p>
                              <p class="subUniqueTitle">{{$any(selectedOffer()!.offer).company.name}}</p>
                              <p class="accountInfoBorder">Price</p>
                              <p class="subUniqueTitle">{{$any(selectedOffer()!.offer).priceForBuyer() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                              <p class="accountInfoBorder">Service Start</p>
                              <p class="subUniqueTitle">1st meter read on or after {{$any(selectedOffer()!.offer).termFrom | date:'shortDate'}}</p>
                              <p class="accountInfoBorder">Service End</p>
                              <p class="subUniqueTitle"> 1st meter read on or after {{getTermTo($any(selectedOffer()!.offer).termFrom, $any(selectedOffer()!.offer).termPeriod) | date:'shortDate'}}</p>
                              <p class="accountInfoBorder">Term</p>
                              <p class="subUniqueTitle grey-text">
                                {{$any(selectedOffer()!.offer).termPeriod}} @if ($any(selectedOffer()!.offer).termPeriod==1) {
                                month
                                }@if ($any(selectedOffer()!.offer).termPeriod>1) {
                                months
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="account-info-block">
                        <div class="card-block-background-block">
                          <div class="icon-block"><div class="fr info-icon" (click)="openNonstopShoppingInfo();"></div></div>
                          <label style="line-height: 27px;"><input type="checkbox" style="margin: auto 5px; vertical-align: middle;" checked="checked" [ngModel]="aiSubscription()" (change)="aiSubscription.update(val => !val)" /> @if(!aiSubscription()){Add }Nonstop Savings Subscription @if(aiSubscription()){Added}</label>
                          <div class="f13 mt-10">
                            Never miss a savings opportunity! <span class="text-nowarp">Nonstop Shop &#174;</span> Al will search daily for future offers throughout the term of your agreement, and autonomously switch you to the lowest price plan available at the end of your service period.
                          </div>
                        </div>
                      </div>
                      @if ($any(selectedOffer()!.offer).sellerContract.disclosureStatement!=null && $any(selectedOffer()!.offer).sellerContract.disclosureStatement.length>0) {
                      <div class="account-info-block">
                        <p class="card-block-background" [class]="(showDisclosureStatement())?'link':'link view-closed'" (click)="changeDisclosureStatement()">
                          Disclosure Statement
                          <a [class]="(showDisclosureStatement())?'collapse':'open'"></a>
                        </p>
                        @if (showDisclosureStatement()) {
                        <div class="visible f13">
                          <div class="f13 p-10" [innerHTML]="$any(selectedOffer()!.offer).sellerContract.disclosureStatement"></div>
                        </div>
                        }
                      </div>
                      }

                      <div class="account-info-block">
                        <p class="card-block-background" [class]="(showSellerContractTerms())?'link':'link view-closed'" (click)="changeSellerContractTermsVisibility()">
                          Sales Agreement
                          <a [class]="(showSellerContractTerms())?'collapse':'open'"></a>
                        </p>
                        @if (showSellerContractTerms()) {
                        <div class="visible f13">
                          <div class="table-view">
                            <!-- Header Row -->
                            <div class="row">
                              <div class="cell">
                                <div class="card-sub-block-background">BUYER</div>
                              </div>
                              <div class="cell">
                                <div class="card-sub-block-background">SELLER</div>
                              </div>
                            </div>

                            <!-- First Name -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">First Name</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">First Name</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().firstName || '-'">{{getUser().firstName || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.firstName || '-'">{{sellOfferContact()?.firstName || '-'}}</p>
                              </div>
                            </div>

                            <!-- Last Name -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Last Name</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Last Name</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().lastName || '-'">{{getUser().lastName || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.lastName || '-'">{{sellOfferContact()?.lastName || '-'}}</p>
                              </div>
                            </div>

                            <!-- Company Name -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Company Name</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Company Name</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="(getUser().company!=null)?getUser().company?.name : '-'">{{(getUser().company!=null)?getUser().company?.name : '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.company?.name || '-'">{{sellOfferContact()?.company?.name || '-'}}</p>
                              </div>
                            </div>

                            <!-- Address Line 1 -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Address Line 1</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Address Line 1</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().addressLine1 || '-'">{{getUser().addressLine1 || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.addressLine1 || '-'">{{sellOfferContact()?.addressLine1 || '-'}}</p>
                              </div>
                            </div>

                            <!-- Address Line 2 -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Address Line 2</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Address Line 2</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().addressLine2 || '-'">{{getUser().addressLine2 || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.addressLine2 || '-'">{{sellOfferContact()?.addressLine2 || '-'}}</p>
                              </div>
                            </div>

                            <!-- City -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">City</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">City</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().city || '-'">{{getUser().city || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.city || '-'">{{sellOfferContact()?.city || '-'}}</p>
                              </div>
                            </div>

                            <!-- State -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">State</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">State</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="(getUser().state != null) ? getUser().state?.name : '-'">{{(getUser().state != null) ? getUser().state?.name : '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="(sellOfferContact()?.state!=null)?sellOfferContact()?.state?.name : '-'">{{(sellOfferContact()?.state!=null)?sellOfferContact()?.state?.name : '-'}}</p>
                              </div>
                            </div>

                            <!-- Zip -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Zip</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Zip</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().zip || '-'">{{getUser().zip || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.zip || '-'">{{sellOfferContact()?.zip || '-'}}</p>
                              </div>
                            </div>

                            <!-- Telephone -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Telephone</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">Telephone</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().phone || '-'">{{getUser().phone || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.phone || '-'">{{sellOfferContact()?.phone || '-'}}</p>
                              </div>
                            </div>

                            <!-- E-mail -->
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">E-mail</p>
                              </div>
                              <div class="cell f13">
                                <p class="accountInfoBorder">E-mail</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().email || '-'">{{getUser().email || '-'}}</p>
                              </div>
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="sellOfferContact()?.email || '-'">{{sellOfferContact()?.email || '-'}}</p>
                              </div>
                            </div>

                            <!-- Tax Exempt & Federal Tax ID (Buyer only) -->
                            @if (getUser().company != null && getUser().company?.taxExempt) {
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Tax Exempt</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle">Yes</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="accountInfoBorder">Federal Tax ID</p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="cell f13">
                                <p class="subUniqueTitle" [attr.title]="getUser().company?.federalTaxID || '-'">{{getUser().company?.federalTaxID || '-'}}</p>
                              </div>
                            </div>
                            }
                          </div>

                          @if ($any(selectedOffer()!.offer).sellerContract.termsDocument!=null) {
                          <div class="f13 p-10">
                            <a class="link" (click)="sendTerms()">View Terms &amp; Conditions <span class="pdf-icon"></span></a>
                          </div>
                          }
                          @if ($any(selectedOffer()!.offer).sellerContract.terms!=null && $any(selectedOffer()!.offer).sellerContract.terms.length>0) {
                          <div class="f13 p-10" [innerHTML]="$any(selectedOffer()!.offer).sellerContract.terms"></div>
                          }

                        </div>
                        }
                      </div>


                      <div>
                        <br>BY CLICKING <strong> ACCEPT OFFER </strong> YOU CERTIFY, ACKNOWLEDGE AND AGREE THAT: <br><br>
                        <div class="p-l-r">
                          <p>
                            (1) YOU HAVE READ, UNDERSTAND AND AGREE TO BE BOUND BY THE ABOVE SELLER CONTRACT ("SALES AGREEMENT") FOR THE UTILITY ACCOUNTS, PRICE, AND SERVICE TERM REFERENCED IN THE ABOVE TRANSACTION SUMMARY, and
                            <br><br>
                            (2) THE SALES AGREEMENT CONSTITUTES A LEGAL AGREEMENT ENTERED INTO BETWEEN YOU ("BUYER") AND THE STATED SALES ENTITY SERVING AS A COUNTER PARTY ("SELLER") TO SUCH SALES AGREEMENT.
                          </p>
                          <p class="font13">
                            You further certify to and agree that you or your representative or agent entering into the Sales Agreement on your behalf is of the legal age of majority and has the right and authority to enter into the Sales Agreement on your own behalf, and that if your representative or agent is entering into said Sales Agreement on behalf of you as a company, organization, educational institution, or agency, instrumentality, or department of the government, that such representative or agent has the right and authority to legally bind you to all the terms and obligations of the Sales Agreement.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
                @if (this.errorY().showError()) {
                <div class="error-block">{{this.errorY().error}}</div>
                }
              </div>
              <div class="block-buttons full-width under-card mt-50">
                <button type="button" (click)="gotoStep(2)">Cancel</button>
                <button appOneClick type="button" class="green-button highlighted-button" (oneClick)="acceptSellOffer()">Accept Offer</button>
              </div>
              <div class="mt-20">&nbsp;</div>
            </div>
            }
            @if (aiSubsctiptionMode()) {
            <div>
              <div class="element-detail mlr-20">
                <div class="account-info-block">
                  <h4>Subscription Summary</h4>
                  <div>
                    @for (rec of formatSelectedAccounts(); track rec; let p = $index) {
                    <p class="accountInfoBorder">{{rec.key}}</p>
                    @for (accountData of rec.value; track accountData; let r = $index) {
                    @if (isPreregisterMode()) {
                    <div class="checkbox-list"><label><input type="checkbox" [checked]="ifItemSelected(accountData.id)" (onchange)="addRemoveAccount(accountData.id, !ifItemSelected(accountData.id))"> {{accountData.accountName}}</label></div>
                    }
                    @if (!isPreregisterMode()) {
                    <div class="subUniqueTitle d-flex">
                      <div>{{(r+1)}}.</div>
                      <div class="auto long-text-cut">{{accountData.accountName}}</div>
                    </div>
                    }
                    }
                    }
                    <div>
                      <p class="accountInfoBorder">Task Name</p>
                      <p class="subUniqueTitle">  Nonstop Shop &#174; </p>
                      <p class="accountInfoBorder">Task Description</p>
                      <p class="subUniqueTitle"> Auto acceptance of price plan offers </p>
                      <p class="accountInfoBorder">Task Trigger Conditions</p>
                      <div class="d-flex">
                        <div class="auto">
                          <div class="mlr-20 f13">
                            Kilowant will lock in only price offers projected to save vs. your alternative price plan
                          </div>
                        </div>
                      </div>
                      <div style="margin-left: 15px; margin-top: 10px;">
                        <p class="accountInfoBorder">Start Date</p>
                        <p class="subUniqueTitle"> {{currentDate.toJSDate() | date:'shortDate'}} </p>
                        <p class="accountInfoBorder">End Date</p>
                        <p class="subUniqueTitle"> N/A </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <br>BY CLICKING <b>SUBSCRIBE</b> YOU CERTIFY, ACKNOWLEDGE AND AGREE THAT: <br><br>
                <div class="p-l-r">
                  <p>
                    (1) YOU AUTHORIZE KILOWANT OR ITS AFFILIATES TO ACT AS YOUR LIMITED, SPECIAL AGENT. THIS ALLOWS KILOWANT TO ENROLL YOU FOR SERVICE WITH ONE OR MORE ENERGY SUPPLIERS AT ANY TIME THAT KILOWANT FINDS A SUPPLIER OFFER IT CALCULATES WILL PROVIDE YOU WITH VALUE. YOU ACKNOWLEDGE THAT ANY SUCH SWITCHING WILL BE DONE ON YOUR BEHALF AND WITH YOUR PRIOR CONSENT FOR THE PURPOSE OF FINDING A BETTER ENERGY RATE.
                  </p>
                  <p>
                    (2) AT THE TIME OF ENROLLMENT YOU WILL RECEIVE AN EMAIL WITH A LINK TO THE SELECTED SUPPLIER'S SERVICES AGREEMENT FOR YOUR REVIEW. YOU WILL HAVE THE RIGHT TO RESCIND THE ENROLLMENT PURSUANT TO THE TERMS OUTLINED IN THE EMAIL.
                  </p>
                </div>
              </div>
              <div class="block-buttons full-width under-card mt-50">
                <button type="button" (click)="gotoStep(2)">Cancel</button>
                <button appOneClick type="button" class="green-button highlighted-button" (oneClick)="generateAITask()">Subscribe</button>
              </div>
              <div class="mt-20">&nbsp;</div>
            </div>
            }
          </div>
        </div>
      </li>
      }
    </ol>
    }
  </div>
    }
    @if ( account() && (step() < 2) ) {
    @if (aiEditMode()) {
    <div class="ai-drawer-backdrop" (click)="aiEditMode.set(false);"></div>
    }
    <div class="footer-bottom-fixed-full-width" [class]="(!aiEditMode())?'':'opened'" [style]="getBottomHeight()">
        <div class="wrapperMain">
            <div class="bottom-selector" style="max-height: none; position: relative;" [class]="(aiEditMode())?'extended':''">
                @if (!aiEditMode()) {
                @if (!activeAITask()) {
                @if (numberOffersLoad()==0) {
                <span class="title f22 mb-20" (click)="openBottomSlide();">
                    Let kilowant AI Shop for You
                </span>
                }
                @if (numberOffersLoad()>0) {
                <span class="title f22 mb-20 p-5" (click)="openBottomSlide();">
                    <span class="f13">Don't see a price plan you like?</span>
                    <br />Let kilowant AI Shop for You
                </span>
                }
                }
                @if (activeAITask()) {
                <span class="title f22 mb-20" (click)="openBottomSlide();">Kilowant AI is Shopping for You</span>
                }
                }
                <div class="bottom-base-area">
                    @if (!activeAITask()) {
                    @if (numberOffersLoad()==0) {
                    @if (aiEditMode()) {
                    <span class="title f22 mb-20" style="text-align: center;" (click)="aiEditMode.set(false);">
                        Let kilowant AI Shop for You
                    </span>
                    }
                    }
                    @if (numberOffersLoad()>0) {
                    @if (aiEditMode()) {
                    <span class="title f22 mb-20 p-5" style="text-align: center;" (click)="aiEditMode.set(false);">
                        <span class="f13">Don't see a price plan you like?</span>
                        <br />Let kilowant AI Shop for You
                    </span>
                    }
                    }
                    }
                    @if (activeAITask()) {
                    @if (aiEditMode()) {
                    <span class="title f22 mb-20" style="text-align: center;" (click)="aiEditMode.set(false);">
                        Kilowant AI is Shopping for You
                    </span>
                    }
                    }

                    @if (numberOffersLoad()!=-1) {
                    <div class="card-block-background-block white f13">
                        @if (!activeAITask()) {
                        @if (numberOffersLoad()==0 && !howItWorksOpened()) {
                        <p class="f16" style="line-height: 35px">
                            <span class="no-dollar"></span>
                            <b>There are No Available Savings Offers</b>
                        </p>
                        <p>The best available price plan offer that our <span class="text-nowarp">Nonstop Shop &#174;</span> AI Agent* has found is simply not good enough to lock in...so we're watching and waiting for a better opportunity. You will be notified via email as soon as we can strike a deal.</p>
                        <div class="bottom-sub-title mb-10">Subscribe to <span class="text-nowarp">Nonstop Shop &#174; AI</span></div>
                        }
                        Our <span class="text-nowarp">Nonstop Shop &#174;</span> AI Agent takes the time and trouble out of shopping.
                        kilowant will search daily for price plan offers that are forecasted to be less expensive than your alternative utility or
                        community energy supply service, autonomously switch you to the provider, and report the savings to you via email.
                        <div>
                            <span class="link blue inline f13 mt-10" style="line-height: 20px;" (click)="howItWorksOpened.update(h=>!h)">
                                How it works <a class="blue" [class]="(howItWorksOpened())?'collapse':'open'"></a>
                            </span>
                        </div>
                        @if (howItWorksOpened()) {
                        <div>
                            <ol class="small-list blue f13">
                                <li>Only price plan offers with forecasted savings vs. your alternative utility or community price plan will qualify for <span class="text-nowarp">Nonstop Shop &#174;</span>.</li>
                                <li>On your behalf <span class="text-nowarp">Nonstop Shop &#174;</span> will automatically accept the lowest priced qualifying offer for your accounts and switch your supplier.  If we can't find savings, we don't switch your price plan.</li>
                                <li>As soon as <span class="text-nowarp">Nonstop Shop &#174;</span> accepts an offer, you will be notified of the offer terms via email with the option to cancel the contract within the designated rescission period. The selected price plan will appear on your utility bill.</li>
                            </ol>
                        </div>
                        }
                        <div style="width: 100%;">
                            <div class="block-buttons full-width mt-20">
                                <button (click)="aiTaskUpdate((hasConsumption())?2:1)" class="highlighted-button">Activate Nonstop Shop &#174; AI</button>
                            </div>
                            @if (howItWorksOpened()) {
                            <div class="f13 mt-20">* You can manage your subscription at any time by going to Main Menu > AI Tasks</div>
                            }
                        </div>
                        }

                        @if (activeAITask()) {
                        @if (numberOffersLoad()==0) {
                        <p class="f16" style="line-height: 35px">
                            <span class="no-dollar"></span>
                            <b>There are No Available Savings Offers</b>
                        </p>
                        <p>The best available price plan offer that our <span class="text-nowarp">Nonstop Shop &#174;</span> Al Agent* has found is simply not good enough to lock in...so we're watching and waiting for a better opportunity. You will be notified via email as soon as we can strike a deal.</p>
                        <div class="f13 mt-10">* You can manage  your subscription at any time by going to Main Menu > AI Tasks</div>
                        }
                        @if (numberOffersLoad()>0) {
                        <p class="f16" style="line-height: 35px">
                            <svg width="50" height="35" viewBox="0 0 50 35" style="float: right; vertical-align: central"><path d="M 5.7,25 19.2,11.4 27,19 42.5,1.8" transform="translate(0,0)" class="price-icon" [class]="getPriceStatsText(offers()[0])"></path></svg>
                            <b>Market Prices are Too High to Buy</b>
                        </p>
                        <p>The best available price plan offer that our <span class="text-nowarp">Nonstop Shop &#174;</span> AI Agent has found is simply not good enough to lock in...so we're watching and waiting for a better opportunity.</p>

                        <div class="tile body round with-ident link" style="margin-left: 0; margin-right: 0">
                            <button class="top-header">
                                <span>{{$any(offers()[0].offer).termPeriod}}</span> @if ($any(offers()[0].offer).termPeriod==1) {
                                Month
                                }@if ($any(offers()[0].offer).termPeriod>1) {
                                Months
                                } starting {{$any(offers()[0].offer).termFrom | date:'MMM yy'}}
                                -
                                {{getTermTo($any(offers()[0].offer).termFrom, $any(offers()[0].offer).termPeriod) | date:'MMM yy'}}
                            </button>
                            <div class="top-info" style="margin-bottom: 0; margin-left: -15px;">
                                <div class="d-flex">
                                    <div class="tile-bolt">1</div>
                                    <div class="auto" #area>
                                        <b class="f18">
                                            {{getPriceStatsSavingsText(offers()[0].savings[diffBenchmark()], false)}}
                                            @if (showViewInUSD(offers()[0])) {
                                            <a (click)="openConsumptionDialog(true, false, account()!, null); $event.stopPropagation();"> <span style="white-space: nowrap;">(View $)</span></a>
                                            }
                                        </b><br />
                                        <span class="auto-renewal">Includes Nonstop Shop<br />Savings Subscription</span>
                                        <div style="width: 100%" [class]="(ifNewOffer(offers()[0]))?'grayish':''">
                                            <div class="d-flex small-info-block" [title]="(ifNewOffer(offers()[0]))?'':'Prices are currently '+getPriceStatsText(offers()[0])">
                                                <div class="price-statistics small visible" style="margin-left: 10px">
                                                    @if (!ifNewOffer(offers()[0])) {
                                                    <div class="price" [ngStyle]="{'transform': 'translateX('+getPriceStatsPercent(offers()[0])+'%)'}">
                                                        <div class="dot"></div>
                                                    </div>
                                                    }
                                                    <div class="statistics" [style]="'width: 100px;'+((!ifPriceStatsAreActive(offers()[0]))?'opacity: 0.5':'')">
                                                        <div class="low"></div>
                                                        <div class="average"></div>
                                                        <div class="high"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        @if (ifNewOffer(offers()[0])) {
                                        <div class="price-statistics-info-block f13">New Price Plan Offer</div>
                                        }
                                        @if (!ifNewOffer(offers()[0]) && ifPriceStatsAreActive(offers()[0])) {
                                        <div class="price-statistics-info-block f13">Prices are <b [class]="getPriceStatsText(offers()[0])">{{getPriceStatsText(offers()[0])}}</b></div>
                                        }
                                        @if (!ifNewOffer(offers()[0]) && !ifPriceStatsAreActive(offers()[0])) {
                                        <div class="price-statistics-info-block f13">No data available</div>
                                        }
                                    </div>
                                    <div style="width: 130px; text-align: right; margin-top: -20px;">
                                        @if (viewSmallChart()[0]!=null) {
                                        <kilowant-charts-home-one-offer [view]="getSquizedView(viewSmallChart()[0])" [legend]="legend" [legendTitle]="legendTitle"
                                                                        [legendPosition]="legendPosition" [showGridLines]="false" [showDataLabel]="false"
                                                                        [scheme]="colorScheme" [showXAxisLabel]="false" [showYAxisLabel]="false"
                                                                        [prefix]="'bottom'"
                                                                        [xAxis]="false" [yAxis]="false" [xAxisLabel]="''" [yAxisLabel]="''"
                                                                        [groupPadding]="2" [barPadding]="5"
                                                                        [results]="offersForChart()[0]"
                                                                        [savings]="savings()"
                                                                        [tooltipDisabled]="true"
                                                                        [showSavingsInUSD]="showSavingsIn()=='USD'"
                                                                        [savingsInUSD]="savingsInUSD()">
                                        </kilowant-charts-home-one-offer>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <span class="link blue inline f13 mt-10" style="line-height: 20px;" (click)="howPricePlansQualifyOpened.update(h=>!h)">
                            How price plans qualify for Nonstop Shop &#174; AI <a class="blue" [class]="(howPricePlansQualifyOpened())?'collapse':'open'"></a>
                        </span>
                        @if (howPricePlansQualifyOpened()) {
                        <div class="small-list blue f13">
                            <div class="cols">
                                <div class="col equal f13 pt-10">
                                    <p class="mb-5"><u>Term (Mths)</u></p>
                                    <p class="mb-5">1-9</p>
                                    <p class="mb-5">10-18</p>
                                    <p class="mb-5">19-36+</p>
                                </div>
                                <div class="col equal f13 pt-10">
                                    <p class="mb-5"><u>Savings (Min)</u></p>
                                    <p class="mb-5">&#8805;5%</p>
                                    <p class="mb-5">&#8805;10%</p>
                                    <p class="mb-5">&#8805;15%</p>
                                </div>
                                <div class="col equal f13 pt-10">
                                    <p class="mb-5"><u>Market Level</u></p>
                                    <p class="mb-5">Low, Avg, High</p>
                                    <p class="mb-5">Low, Avg</p>
                                    <p class="mb-5">Low</p>
                                </div>
                            </div>
                        </div>
                        }
                        <div class="f13 mt-10">You can still shop current price plan offers at any time while <span class="text-nowarp">Nonstop Shop &#174;</span> AI is activated</div>
                        <div class="block-buttons full-width mt-20">
                            <button (click)="aiEditMode.set(false);" class="highlighted-button">View Available Offers</button>
                        </div>
                        <div class="f13 mt-10">* You can manage  your subscription at any time by going to Main Menu > AI Tasks</div>
                        }
                        }

                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</div>
